import _colors from "tailwindcss/colors";

export const colors = _colors;
